import React, { useEffect } from 'react';
import './InvoiceOptions.css';

const InvoiceOptions = ({
  showHsnColumn,
  setShowHsnColumn,
  taxType,
  setTaxType,
  gstRate,
  setGstRate,
  igstRate,
  setIgstRate,
  hasdiscount,
  setHasdiscount,
  discount,
  setDiscount,
  isMobile
}) => {
  // Force HSN OFF whenever tax type becomes NONE
  useEffect(() => {
    if (taxType === 'NONE' && showHsnColumn) {
      setShowHsnColumn(false);
    }
  }, [taxType, showHsnColumn, setShowHsnColumn]);

  // Safe computed flag for the toggle UI
  const safeShowHsn = taxType !== 'NONE' ? showHsnColumn : false;

  // Only allow manual toggle when tax is applicable
  const handleHsnToggle = () => {
    if (taxType !== 'NONE') {
      setShowHsnColumn(!showHsnColumn);
    }
  };

  return (
    <div className="InvoiceForm__options-container">
      {/* Tax Configuration Heading */}
      <div>
        <label className="InvoiceForm__label--top">Tax Configuration</label>
      </div>

      {/* Radio options (No Tax first) */}
      <div className="InvoiceForm__radio-group-horizontal">
        <div className="InvoiceForm__radio-item">
          <input
            type="radio"
            id="no_tax"
            name="taxType"
            value="NONE"
            checked={taxType === 'NONE'}
            onChange={(e) => setTaxType(e.target.value)}
            className="InvoiceForm__radio"
          />
          <label htmlFor="no_tax" className="InvoiceForm__radio-label">
            No Tax
          </label>
        </div>

        <div className="InvoiceForm__radio-item">
          <input
            type="radio"
            id="sgst_cgst"
            name="taxType"
            value="SGST_CGST"
            checked={taxType === 'SGST_CGST'}
            onChange={(e) => setTaxType(e.target.value)}
            className="InvoiceForm__radio"
          />
          <label htmlFor="sgst_cgst" className="InvoiceForm__radio-label">
            SGST + CGST
          </label>
        </div>

        <div className="InvoiceForm__radio-item">
          <input
            type="radio"
            id="igst"
            name="taxType"
            value="IGST"
            checked={taxType === 'IGST'}
            onChange={(e) => setTaxType(e.target.value)}
            className="InvoiceForm__radio"
          />
          <label htmlFor="igst" className="InvoiceForm__radio-label">
            IGST
          </label>
        </div>
      </div>

      {/* GST/IGST Rate */}
      {(taxType === 'SGST_CGST' || taxType === 'IGST') && (
        <div className="InvoiceForm__field-group">
          <label className="InvoiceForm__label">
            {taxType === 'SGST_CGST' ? 'GST Rate (%)' : 'IGST Rate (%)'}
          </label>
          <input
            type="text"
            inputMode="decimal"
            className="InvoiceForm__input InvoiceForm__input--no-spinner"
            value={taxType === 'SGST_CGST' ? gstRate : igstRate}
            onChange={(e) => {
              const value = e.target.value;
              if (taxType === 'SGST_CGST') {
                if (
                  value === '' ||
                  (/^\d*\.?\d*$/.test(value) &&
                    parseFloat(value) >= 0 &&
                    parseFloat(value) <= 50)
                ) {
                  setGstRate(value === '' ? 0 : parseFloat(value) || 0);
                }
              } else if (taxType === 'IGST') {
                if (
                  value === '' ||
                  (/^\d*\.?\d*$/.test(value) &&
                    parseFloat(value) >= 0 &&
                    parseFloat(value) <= 100)
                ) {
                  setIgstRate(value === '' ? 0 : parseFloat(value) || 0);
                }
              }
            }}
          />
        </div>
      )}

      {/* HSN Toggle (visible only for taxable types, stays OFF until user toggles) */}
      {(taxType === 'SGST_CGST' || taxType === 'IGST') && (
        <div className="InvoiceForm__toggle-group">
          <label className="InvoiceForm__toggle-label">Include HSN/SAC</label>
          <div
            className={`InvoiceForm__toggle ${safeShowHsn ? 'InvoiceForm__toggle--active' : ''}`}
            onClick={handleHsnToggle}
          >
            <div className="InvoiceForm__toggle-slider"></div>
          </div>
        </div>
      )}

      {/* Discount Toggle */}
      <div className="InvoiceForm__toggle-group">
        <label className="InvoiceForm__toggle-label">Include Discount</label>
        <div
          className={`InvoiceForm__toggle ${hasdiscount ? 'InvoiceForm__toggle--active' : ''}`}
          onClick={() => setHasdiscount(!hasdiscount)}
        >
          <div className="InvoiceForm__toggle-slider"></div>
        </div>
      </div>

      {/* Discount Rate */}
      {hasdiscount && (
        <div className="InvoiceForm__field-group InvoiceForm__discount-rate-field-group">
          <label className="InvoiceForm__label">Discount (%)</label>
          <input
            type="text"
            inputMode="decimal"
            className="InvoiceForm__input InvoiceForm__input--small InvoiceForm__input--no-spinner"
            value={discount}
            onChange={(e) => {
              const value = e.target.value;
              if (
                value === '' ||
                (/^\d*\.?\d*$/.test(value) &&
                  parseFloat(value) >= 0 &&
                  parseFloat(value) <= 100)
              ) {
                setDiscount(value === '' ? 0 : parseFloat(value) || 0);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default InvoiceOptions;
